import { SyncRoute } from "@/components/Search/SearchResults/components/syncRoute/syncRoute.container";

import { useInitSearch } from "../../hooks/useInitSearch";

export const InitSearch = () => {
    const { initialized } = useInitSearch();

    if (!initialized) return null;

    return <SyncRoute />;
};
